// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ewK5ny6gr2tTLMDvfckG {
  width: 100%;
}

.KvifF7HuXkdbeRV0Fxzd {
  background-color: var(--sl-bg-base-soft);
  border-radius: var(--sl-radius-2);
  height: 345px;
}

.MwTFBAbrUGnucmkZPBcg {
  padding: var(--sl-space-3);
  background-color: var(--sl-bg-base);
  border-radius: var(--sl-radius-2);
  border: var(--sl-border-base);
}

.uC1EhuSH0qegfjxrw_aK {
  gap: var(--sl-space-2);
  margin-bottom: calc(var(--sl-space-6) * -1);
  margin-left: auto;
  padding-right: var(--sl-space-3);
}

.sGNwetZlOIjHeijP8DAn {
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: var(--sl-bg-muted-plain-hover);
  }

  &.VcFLUnADdPO3K8kqRqAV {
    border: var(--sl-border-accent-strong);
    background-color: var(--sl-color-blue-1);

    &:hover {
      border: var(--sl-border-accent-strong-hover);
    }
  }
}

.N6nTOdDQzIRU9v9JfJ9C {
  z-index: 1000;
}

.iSC3ksJo5GWPNSy4KpjT {
  height: 100%;
}

.XcCFwVAw9C_EY6iHMJ5E {
  flex: 1;
  background-color: var(--sl-bg-base-soft);
  padding: var(--sl-space-5);
  padding-bottom: var(--sl-space-0);
  border-radius: var(--sl-radius-2);
}

.co2KaIpOcxvkX4RFo3XO {
  flex: 1;
  background-color: var(--sl-bg-base-strong);
  border-radius: var(--sl-radius-2);
  padding: var(--sl-space-4);
  margin-bottom: var(--sl-space-5);
}

.s4hXcXSS3RAaZHSvhqhS {
  flex: 1;
  overflow-y: auto;
}

.s4hXcXSS3RAaZHSvhqhS > *:last-child {
  margin-bottom: var(--sl-space-5);
}

.oZGuUnR0dSnPZntakx1R {
  border-radius: var(--sl-radius-2);
  min-height: 100px;
}

.BHFP74EFwL2qiCRKulvS {
  object-fit: contain;
}

.d6CfkzPuOBZepkoI0SUH {
  color: var(--sl-fg-base-soft);
}

.jaQe7b5XjhxK75TLDI5D {
  text-align: center;
}

.jKltHg96PdlJYwVsThdS {
  text-align: end;
}

.XU6jHodDP1ZOKCVyPcRh {
  color: var(--sl-fg-critical);

  &:hover {
    color: var(--sl-fg-critical-hover);
    background-color: var(--sl-bg-critical-plain-hover);
  }
}

._In6T3hMOI3eeJN_rNyM {
  margin: var(--sl-space-0) !important;
}

.SkKumz8rYZlvZZU1g1Oy {
  flex: 1;
}

.uu9JS916VY4woVCCqtZF {
  flex: 1;
  overflow-y: auto;
}

.QpqAObNnexnvtEkJBf1N {
  overflow-y: hidden;
}

.NHTINhCabqofxUiyCMYH {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/ScreensGroups/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;;EAEhC;IACE,gDAAgD;EAClD;;EAEA;IACE,sCAAsC;IACtC,wCAAwC;;IAExC;MACE,4CAA4C;IAC9C;EACF;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,wCAAwC;EACxC,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,0CAA0C;EAC1C,iCAAiC;EACjC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;;EAE5B;IACE,kCAAkC;IAClC,mDAAmD;EACrD;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".container {\n  width: 100%;\n}\n\n.emptyStateContainer {\n  background-color: var(--sl-bg-base-soft);\n  border-radius: var(--sl-radius-2);\n  height: 345px;\n}\n\n.groupContainer {\n  padding: var(--sl-space-3);\n  background-color: var(--sl-bg-base);\n  border-radius: var(--sl-radius-2);\n  border: var(--sl-border-base);\n}\n\n.selectAllCheckbox {\n  gap: var(--sl-space-2);\n  margin-bottom: calc(var(--sl-space-6) * -1);\n  margin-left: auto;\n  padding-right: var(--sl-space-3);\n}\n\n.selectableScreen {\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    background-color: var(--sl-bg-muted-plain-hover);\n  }\n\n  &.checked {\n    border: var(--sl-border-accent-strong);\n    background-color: var(--sl-color-blue-1);\n\n    &:hover {\n      border: var(--sl-border-accent-strong-hover);\n    }\n  }\n}\n\n.modalHeaderContainer {\n  z-index: 1000;\n}\n\n.modalContent {\n  height: 100%;\n}\n\n.modalScreensContainer {\n  flex: 1;\n  background-color: var(--sl-bg-base-soft);\n  padding: var(--sl-space-5);\n  padding-bottom: var(--sl-space-0);\n  border-radius: var(--sl-radius-2);\n}\n\n.modalNoScreensContainer {\n  flex: 1;\n  background-color: var(--sl-bg-base-strong);\n  border-radius: var(--sl-radius-2);\n  padding: var(--sl-space-4);\n  margin-bottom: var(--sl-space-5);\n}\n\n.modalListContainer {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.modalListContainer > *:last-child {\n  margin-bottom: var(--sl-space-5);\n}\n\n.skeleton {\n  border-radius: var(--sl-radius-2);\n  min-height: 100px;\n}\n\n.image {\n  object-fit: contain;\n}\n\n.textSoft {\n  color: var(--sl-fg-base-soft);\n}\n\n.textCenter {\n  text-align: center;\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.buttonCritical {\n  color: var(--sl-fg-critical);\n\n  &:hover {\n    color: var(--sl-fg-critical-hover);\n    background-color: var(--sl-bg-critical-plain-hover);\n  }\n}\n\n.marginZero {\n  margin: var(--sl-space-0) !important;\n}\n\n.flexOne {\n  flex: 1;\n}\n\n.overflowAuto {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.overflowHidden {\n  overflow-y: hidden;\n}\n\n.marginLeftAuto {\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ewK5ny6gr2tTLMDvfckG`,
	"emptyStateContainer": `KvifF7HuXkdbeRV0Fxzd`,
	"groupContainer": `MwTFBAbrUGnucmkZPBcg`,
	"selectAllCheckbox": `uC1EhuSH0qegfjxrw_aK`,
	"selectableScreen": `sGNwetZlOIjHeijP8DAn`,
	"checked": `VcFLUnADdPO3K8kqRqAV`,
	"modalHeaderContainer": `N6nTOdDQzIRU9v9JfJ9C`,
	"modalContent": `iSC3ksJo5GWPNSy4KpjT`,
	"modalScreensContainer": `XcCFwVAw9C_EY6iHMJ5E`,
	"modalNoScreensContainer": `co2KaIpOcxvkX4RFo3XO`,
	"modalListContainer": `s4hXcXSS3RAaZHSvhqhS`,
	"skeleton": `oZGuUnR0dSnPZntakx1R`,
	"image": `BHFP74EFwL2qiCRKulvS`,
	"textSoft": `d6CfkzPuOBZepkoI0SUH`,
	"textCenter": `jaQe7b5XjhxK75TLDI5D`,
	"textEnd": `jKltHg96PdlJYwVsThdS`,
	"buttonCritical": `XU6jHodDP1ZOKCVyPcRh`,
	"marginZero": `_In6T3hMOI3eeJN_rNyM`,
	"flexOne": `SkKumz8rYZlvZZU1g1Oy`,
	"overflowAuto": `uu9JS916VY4woVCCqtZF`,
	"overflowHidden": `QpqAObNnexnvtEkJBf1N`,
	"marginLeftAuto": `NHTINhCabqofxUiyCMYH`
};
export default ___CSS_LOADER_EXPORT___;
